import { useEffect } from 'react'
import { ThemeState, useThemeStore } from '../storage/storage.service'

/** Carbon Design System theme classes: cds--white (light), cds--g100 (dark) */
const CARBON_THEME_LIGHT = 'cds--white'
const CARBON_THEME_DARK = 'cds--g100'

export const useThemeSync = () => {
  const theme = useThemeStore((s: ThemeState) => s.theme)

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove(CARBON_THEME_LIGHT, CARBON_THEME_DARK)
    root.classList.add(theme === 'dark' ? CARBON_THEME_DARK : CARBON_THEME_LIGHT)
  }, [theme])
}
